module.exports = __webpack_public_path__ + "img/1-TWK-Splash-Page-MVP.a9f07368.png";